<template>
  <div>
    <div class="contentBigBox">
      <!--<div class="closeSplitScreen el-icon-circle-close" @click="closeSplitScreen"></div>-->
      <div class="details-title">
        <div>{{ taskListTitle.name }}</div>
        <div>
          <span v-if="taskListTitle.categoryName != null">抽样类型: {{ taskListTitle.categoryName }}</span>
        </div>
      </div>
      <el-tabs type="card" v-model="activeName" v-if="statusList == 20" @tab-click="tabClick">
        <el-tab-pane :label="`待质控(${doctor.sampling})`" name="123">待质控</el-tab-pane>
        <el-tab-pane :label="`已完成(${doctor.pending})`" name="130">已完成</el-tab-pane>
      </el-tabs>
      <el-row :gutter="30" v-loading="loading">
        <el-col :span="tootipType ? 12 : 24">
          <el-table class="qcTable doctor doctorIsRead" ref="multipleTable" :data="list" highlight-current-row>
            <el-table-column prop="QCTimes" label="读取进度" v-if="statusList == 50" width="150">
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  v-if="scope.row.IsRead == 1"
                  @click="handleClick(scope.row)"
                  class="read isread"
                  size="mini"
                  round
                >
                  已读
                </el-button>
                <el-button type="info" v-else size="mini" @click="handleClick(scope.row)" class="read" round>
                  未读
                </el-button>
              </template>
            </el-table-column>
            <el-table-column prop="AccNo" min-width="110" label="报告编号"></el-table-column>
            <el-table-column prop="ModalityType" label="设备类型" width="80"></el-table-column>
            <el-table-column prop="CheckingItems" label="检查项目" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column v-if="exportTackStatus > 123" min-width="80" prop="Score" label="得分"></el-table-column>
            <el-table-column prop="TotalStatus" label="状态">
              <template slot-scope="scope">
                <div>
                  <span>{{ scope.row.TotalStatus | formatStatus }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="CreateDtStr"
              min-width="150"
              :formatter="formattertime"
              label="创建时间"
            ></el-table-column>
            <el-table-column prop="" label="操作" fixed="right" width="180">
              <template slot-scope="scope">
                <span class="tableOpe" v-if="scope.row.TotalStatus <= 123" @click="handleClick(scope.row, 'table')">
                  查看详情
                </span>
                <span
                  class="tableOpe"
                  v-else-if="scope.row.TotalStatus >= 130 && scope.row.ExpertUserGuids.length <= 1"
                  @click="handleClick(scope.row, 'length')"
                >
                  查看结果
                </span>
                <span class="tableOpe" v-else @click="handleCurrentChange(scope.row, scope.$index, $event)">
                  查看结果
                </span>
              </template>
            </el-table-column>
          </el-table>
        </el-col>

        <el-col v-show="tootipType" :span="12" class="exporttootip" :style="{ minHeight: height }">
          <i ref="toopIcon" class="tootipCaretLeft el-icon-caret-left"></i>
          <div class="title">
            此报告有 {{ qcresultsByTaskList.length }} 位专家参与质控
            <i class="el-icon-close" @click="closeRbox"></i>
          </div>
          <ul class="qcresultsBox" :style="{ height: height, minHeight: '85px' }">
            <li v-for="item in qcresultsByTaskList" :key="item.Name" class="qcresults">
              <el-row>
                <el-col :span="6">专家 : {{ item.Name | filtName }}</el-col>
                <el-col :span="6">报告评分 : {{ item.ReportScore }}</el-col>
                <el-col :span="6">影像评分 : {{ item.ImageScore }}</el-col>
                <el-col :span="6" class="textr">
                  <el-button type="primary" v-if="item.ReadStatus == 1" class="read isread" size="mini" round>
                    已读
                  </el-button>
                  <el-button type="primary" v-else size="mini" @click="handleClick(item)" class="read" round>
                    未读
                  </el-button>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="18">完成时间 : {{ item.QCDt }}</el-col>
                <el-col :span="6" class="tableOpe textr">
                  <span @click="handleClick(item)">查看详情</span>
                </el-col>
              </el-row>
            </li>
          </ul>
        </el-col>
      </el-row>
      <div class="pages">
        <el-pagination
          class="pageAll"
          v-if="pageshow"
          layout="prev, pager, next"
          :total="totalsecond"
          :page-size="listParameter.PageCount"
          :current-page="pageIndex.page"
          @current-change="currentChange"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<style scoped>
.contentBigBox {
  padding-top: 36px;
}
</style>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
export default {
  data() {
    return {
      activeName: "130",
      height: 0,
      datas: {},
      pageshow: true,
    };
  },
  filters: {
    filtName: function(value) {
      return new Array(value.length).join("*") + value.substr(-1);
    },
    formatStatus: function(value) {
      return (
        {
          "": "不限",
          "120": "已抽样",
          "123": "已分配",
          "125": "进行中",
          "130": "已完成",
          "140": "申诉中",
          "170": "已归档",
        }[value] || "不限"
      );
    },
  },
  computed: {
    ...Vuex.mapState("breadcrumb", ["tootipType", "selectRow", "loading"]),
    ...Vuex.mapState("doctor", [
      "samplingTaskGuid",
      "doctor",
      "list",
      "listParameter",
      "taskListTitle",
      "totalsecond",
      "pageIndex",
      "TaskListArr",
      "statusList",
      "exportTackStatus",
      "exportTackStatus",
    ]),
    ...Vuex.mapState("managerPlanList", ["qcresultsList", "qcresultsByTaskList"]),
    lists() {
      return this.list;
    },
  },
  watch: {
    lists(old) {
      let _this = this;
      if (this.selectRow.row != 1) {
        this.pageIndex.page = this.selectRow.pageIndex;
        this.pageshow = false;
        this.$nextTick(() => {
          _this.pageshow = true;
          _this.$refs.multipleTable.setCurrentRow(_this.list[_this.selectRow.index]);
        });
        if (_this.list) {
          this.GetQCResultsByTask({
            samplingtaskguid: _this.list[_this.selectRow.index].SamplingTaskGuid,
            reportGuid: _this.list[_this.selectRow.index].ReportGuid,
          });
        }
      } else {
        this.$refs.multipleTable.setCurrentRow();
      }
      this.currentChangesSecond(this.selectRow.pageIndex);
      let ele = document.getElementsByClassName("qcTable")[0];
      if (ele) {
        _this.height = document.getElementsByClassName("qcTable")[0].offsetHeight - 60 + "px";
      }
    },
  },
  mounted() {
    this.currentChangesSecond(1);
  },
  activated() {
    this.setLoading(true);
    if (this.taskListTitle.type == 1) {
      this.samplingTaskGuid.id = "";
    }
    if (this.statusList == "15") {
      this.exportDoctorStatusMu(123);
    } else {
      this.exportDoctorStatusMu(130);
    }
    this.selectRow.pageIndex = 1;
    this.pageIndex.page = 1;
    this.GetReporterReportList();
  },
  methods: {
    ...Vuex.mapMutations("breadcrumb", ["setqcresultsShow", "setTootipType"]),
    ...Vuex.mapMutations("doctor", [
      "setisSubmintflag",
      "setIsSubmint",
      "setDetalLoading",
      "setReportGuid",
      "setDetailsParameter",
      "taskListShowMu",
      "currentChangesSecond",
      "setSplitScreen",
      "exportDoctorStatusMu",
      "setLoading",
    ]),
    ...Vuex.mapActions("doctor", ["GetReporterReportList", "UpdateReportReadStatus", "GetTaskList"]),
    ...Vuex.mapActions("managerPlanList", ["GetQCResultsByTask"]),
    closeRbox() {
      this.setTootipType(false);
      this.$refs.multipleTable.setCurrentRow();
    },
    // 右侧出现专家列表
    handleCurrentChange(val, index, e) {
      let _this = this;
      this.selectRow.index = index;
      this.selectRow.row = val;
      this.currentRow = val;
      let target = e.target || e.originalTarget || e.toElement || e.path[0];
      let parent = e.currentTarget.parentElement.parentElement;
      if (target.tagName == "SPAN" || target.nodeName == "SPAN") {
        this.setTootipType(true);
        this.datas.ReportGuid = val.ReportGuid;
        this.datas.SamplingTaskGuid = val.SamplingTaskGuid;
        this.GetQCResultsByTask({
          samplingtaskguid: val.SamplingTaskGuid,
          reportGuid: val.ReportGuid,
        });
        let difference = parent.offsetHeight / 2;
        _this.$refs.toopIcon.style.top = parent.offsetTop + difference + 25 + "px";
        let ele = document.getElementsByClassName("qcTable")[0];
        if (ele) {
          _this.height = document.getElementsByClassName("qcTable")[0].offsetHeight - 60 + "px";
        }
      }
    },
    handleClick(val) {
      this.setDetalLoading(true);
      //详情不可编辑
      this.setIsSubmint(true);
      this.setisSubmintflag(true);
      this.setqcresultsShow(false);
      let arg = arguments[1];
      this.qcresultsList.Name = val.Name;
      if (arg) {
        this.setReportGuid(val.ReportGuid);
        this.samplingTaskGuid.ExpertUserId = val.ExpertUserGuids[0];
        this.qcresultsList.expertUserId = val.ExpertUserGuids[0];
        this.qcresultsList.ReportGuid = val.ReportGuid;
        this.qcresultsList.SamplingTaskGuid = val.SamplingTaskGuid;
        this.UpdateReportReadStatus({
          samplingTaskGuid: val.SamplingTaskGuid,
        });
      } else {
        this.setReportGuid(this.datas.ReportGuid);
        this.samplingTaskGuid.ExpertUserId = val.ExpertUserId;
        this.qcresultsList.expertUserId = val.ExpertUserId;
        this.qcresultsList.ReportGuid = this.datas.ReportGuid;
        this.qcresultsList.SamplingTaskGuid = this.datas.SamplingTaskGuid;
        this.UpdateReportReadStatus({
          samplingTaskGuid: this.datas.SamplingTaskGuid,
        });
      }
      this.GetReporterReportList();
      this.setDetailsParameter({
        reportGuid: this.qcresultsList.ReportGuid,
        samplingTaskGuid: this.qcresultsList.SamplingTaskGuid,
        ExpertUserGuid: this.qcresultsList.expertUserId,
      });
      this.GetQCResultsByTask({
        samplingtaskguid: this.qcresultsList.SamplingTaskGuid,
        reportGuid: this.qcresultsList.ReportGuid,
      });
      // this.GetReportDetail();
      this.$router.push("/home/doctor/scoring");
    },
    formattertime(row, column, cellValue) {
      if (cellValue != "" && cellValue != null) {
        return cellValue.substring(0, cellValue.length - 3);
      } else {
        return cellValue;
      }
    },
    //分页
    currentChange(val) {
      this.setLoading(true);
      this.selectRow.pageIndex = val;
      this.setTootipType(false);
      this.currentChangesSecond(val);
      this.GetReporterReportList();
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    },
    tabClick(tab, event) {
      this.setLoading(true);
      this.exportDoctorStatusMu(tab.name);
      this.GetReporterReportList();
    },
    array2Str: function(datas) {
      if (datas) {
        let str = "";
        for (let i = 0; i < datas.length; i++) {
          str += "<p>" + datas[i] + "</p>";
        }
        return str;
      }
    },
  },
};
</script>
